import React from "react";

const AxisSelectionFilterCheckboxInput = ({ label, checked, onChange, disabled, isLoading, title }) => {
  return (
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        className={`checked:bg-secondary rounded-sm border-gray-400 checked:border-secondary
        ${isLoading ? "cursor-wait" : disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
        checked={checked}
        onChange={onChange}
        disabled={disabled || isLoading}
        title={title}
      />
      <span className={`${isLoading ? "cursor-wait" : disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
        {label}
      </span>
    </div>
  );
};

export default AxisSelectionFilterCheckboxInput;
